<div class="league">
    <div class="name">ECL</div>
    <div>{{ season }}</div>
</div>
